import axiosClient from '@/config/api/axios'
import { WORKFLOWS } from '@/config/api/endpoints'
import { isApiConfigured } from '@/config/api/env'
import { workflowFromRow } from './workflowMappers'

export function isWorkflowsApiAvailable() {
  return isApiConfigured()
}

/** Workflow *definitions* for the signed-in user (the API filters run rows). */
export async function fetchWorkflows(options = {}) {
  if (!isWorkflowsApiAvailable()) return []
  const { data } = await axiosClient.get(WORKFLOWS, { signal: options.signal })
  return (Array.isArray(data) ? data : []).map(workflowFromRow)
}

/**
 * Authorise this workflow to send unattended, bound to named recipients.
 *
 * Its own call rather than part of an edit: the server recomputes the binding
 * hash from the stored definition, so granting and editing must stay separate.
 */
export async function grantWorkflowSends({ workflowId, actions, maxSendsPerRun, expiresAt }) {
  const { data } = await axiosClient.post(`${WORKFLOWS}/${workflowId}/send-grant`, {
    actions,
    max_sends_per_run: maxSendsPerRun,
    expires_at: expiresAt,
  })
  return workflowFromRow(data)
}

export async function revokeWorkflowSends({ workflowId }) {
  const { data } = await axiosClient.delete(`${WORKFLOWS}/${workflowId}/send-grant`)
  return workflowFromRow(data)
}
